import React, { Component } from 'react';
import { Form, Segment, Button, Divider } from 'semantic-ui-react';
import { base, toCurrency, pythonApiIp, ViewOrderLinkAlgolia, logComponentLoad } from '../../../../config/constants.js'
import * as FbUtils from '../../../../Utilities/FireBaseUtils.js';
import Status from '../../../../config/OrderStatusConstants.js'
import * as moment from 'moment';
import axios from 'axios'
import { serverIp, firebaseAuth } from '../../../../config/constants.js'
import * as UiConsts from '../../../../config/UiConstants.js'
import RecItem from './RecItem'
import { SingleDatePicker } from 'react-dates';
import { checkAdminEmail } from '../../../dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils';
import { getDiscountCodesDropdown } from '../LargeProjects/LargeProjectUtils'
import Select from 'react-select';
import ItemCosts from '../ItemCosts/ItemCosts.js';


class EnterReceiptsDynamic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reciept_num: '',
            order_num: '',
            amountDep: '',
            amountRec: '',
            amountDepConfirm: '',
            amountRecConfirm: '',
            selectedItem: '',
            qty1: '',
            price1: '',
            item1: '',
            samplePrice: '',
            loading: false,
            sentOrders: [],
            orderNumList: [],
            receipNumOk: false,
            orderItemsArray: [],
            date: '',
            itemCosts: [],
            // checkingReceiptComplete:true,
            // checkingOrderNumComplete:true,
            samplePricing: [
                // {
                //     "category": "samplePrice",
                //     "label": "15000",
                //     "value": 15000,
                // },
                {
                    "category": "samplePrice",
                    "label": "25000",
                    "value": 25000,
                },
                {
                    "category": "samplePrice",
                    "label": "35000",
                    "value": 35000,
                },
                {
                    "category": "samplePrice",
                    "label": "40000",
                    "value": 40000,
                },
                {
                    "category": "samplePrice",
                    "label": "40000",
                    "value": 50000,
                },
                {
                    "category": "samplePrice",
                    "label": "60000",
                    "value": 60000,
                },

            ],

            quickSelectChoices: [
                {
                    "category": "quickSelect",
                    "label": "jersey_no_deposit",
                    "value": "jersey_no_deposit",
                },
                {
                    "category": "quickSelect",
                    "label": "jersey_HALF_deposit",
                    "value": "jersey_HALF_deposit",
                },
                {
                    "category": "quickSelect",
                    "label": "jersey_FULL_deposit",
                    "value": "jersey_FULL_deposit",
                },
                {
                    "category": "quickSelect",
                    "label": "jumper_HALF_deposit",
                    "value": "jumper_HALF_deposit",
                },
                {
                    "category": "quickSelect",
                    "label": "jumper_NO_deposit",
                    "value": "jumper_NO_deposit",
                },
                {
                    "category": "quickSelect",
                    "label": "t_shirt_HALF_deposit_40k",
                    "value": "t_shirt_HALF_deposit_40k",
                },
                {
                    "category": "quickSelect",
                    "label": "t_shirt_HALF_deposit_35k",
                    "value": "t_shirt_HALF_deposit_35k",
                },


            ],
        }
    }

    componentDidMount() {
        console.log("entx8 +++++ componentDidMount - ");
        this.initOrderItemsArray();
        this.getDiscountCodes();

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }

        })
    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("enter returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "EnterReceiptsDynamic");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    handleOrderDetailsDropDownChanges = (value) => {
        console.log('gbv1 You\'ve sss:', value);
        console.log('gbv12 You\'ve selected:', value.value + " " + value.category);

        let newState = {};
        newState[value.category] = value.value;

        this.setState(newState);

        if (value.category === 'selectedItem') {
            let tempNew1 = { "item_id": value.item_id, "name": value.label };
            this.setState({ item1: tempNew1 });

        } else if (value.category === 'quickSelect') {
            console.log("qsx1: quickSelect dropdown.....");

            if (value.value === 'jersey_no_deposit') {
                console.log("qsx1: quickSelect value jersey_no_deposit.....");

                let tempNew1 = { "item_id": '1474236000000066254', "name": "football_jersey" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 0,
                    amountRec: 40000,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 40000,
                    price1: 40000

                });
            } else if (value.value === 'jersey_HALF_deposit') {
                console.log("qsx1: quickSelect value jersey_HALF_deposit.....");

                let tempNew1 = { "item_id": '1474236000000066254', "name": "football_jersey" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 20000,
                    amountRec: 20000,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 40000,
                    price1: 40000

                });
            } else if (value.value === 'jersey_FULL_deposit') {
                console.log("qsx1: quickSelect value jersey_no_deposit.....");

                let tempNew1 = { "item_id": '1474236000000066254', "name": "football_jersey" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 40000,
                    amountRec: 0,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 40000,
                    price1: 40000

                });

            } else if (value.value === 'jumper_HALF_deposit') {
                console.log("qsx1: quickSelect value jumper_HALF_deposit.....");

                let tempNew1 = { "item_id": '1474236000000066417', "name": "jumper" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 30000,
                    amountRec: 30000,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 60000,
                    price1: 60000

                });
            } else if (value.value === 'jumper_NO_deposit') {
                console.log("qsx1: quickSelect value jumper_NO_deposit.....");

                let tempNew1 = { "item_id": '1474236000000066417', "name": "jumper" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 0,
                    amountRec: 60000,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 60000,
                    price1: 60000

                });
            } else if (value.value === 't_shirt_HALF_deposit_40k') {
                console.log("qsx1: quickSelect value t_shirt_HALF_deposit_40k.....");

                let tempNew1 = { "item_id": '1474236000000066216', "name": "t_shirt" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 20000,
                    amountRec: 20000,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 40000,
                    price1: 40000

                });
            } else if (value.value === 't_shirt_HALF_deposit_35k') {
                console.log("qsx1: quickSelect value t_shirt_HALF_deposit_35k.....");

                let tempNew1 = { "item_id": '1474236000000066216', "name": "t_shirt" };
                this.setState({
                    item1: tempNew1,
                    amountDep: 17500,
                    amountRec: 17500,
                    numItems1: 1,
                    qty1: 1,
                    samplePrice: 35000,
                    price1: 35000

                });
            } else {
                console.log("qsx1: quickSelect value NOT FOUND.....");
            }
        }


    }

    sendForm = () => {
        console.log("+++++ sendForm");
    }

    // ##########################::  FIRST :##########################:
    checkReceiptNumAndOrderNum = () => {
        console.log("entx1 +++++ checkReceiptNumAndOrderNum - ");

        if (this.state.reciept_num.length < 4) {
            alert("reciept_num be atleast 4 chars");

        } else if (isNaN(this.state.reciept_num)) {
            alert("reciept_num must be a number");

        } else if (this.state.order_num.length < 4) {
            alert("order_num be atleast 4 chars");

        } else {

            this.setState({ loading: true });

            let trans = {};

            //ADD RECEIPT NUM
            trans.reciept_num = this.state.reciept_num;

            //ADD ORDER NUMBERS
            if (!this.getOrderNumList()) {
                console.log("entx121 order num list is fuct");
            } else {
                trans.orderNumList = this.getOrderNumList();

                console.log("entx122 checking order numbers");

                // SEND CHECK TO SERVER
                axios.post(serverIp + 'billing/checkRecieptNumAndOrderNumbers', {
                    reciept_num: this.state.reciept_num,
                    orderNumList: trans.orderNumList
                })
                    .then((response) => {
                        // console.log("entx221 response:" + JSON.stringify(response.data, null, 3));

                        //console.log("entx22 result:" + response.data.result);

                        // CHECK RECEIPTS
                        if (response.data.orderNumAndReceipt.badRecieptNum) {
                            //console.log("entx23 recieptNum already there");

                            alert("Reciept num: " + this.state.reciept_num + " already in system");

                            this.setState({ loading: false });

                            // CHECK ORDER NUMBER
                        } else if (response.data.orderNumAndReceipt.orderNumsOk === false) {
                            // console.log("invalid order numbers:" + response.data.orderNumAndReceipt.badOrderNums.toString());
                            alert("invalid order numbers or not in Out For Delivery Or Delivered:" + response.data.orderNumAndReceipt.badOrderNums.toString());
                            this.setState({ loading: false });

                        } else {
                            alert("all is well proceed")
                            //  console.log("all is well, orders being marked delivered");

                            // MARK ORDER DELIVERED
                            // for (var i = 0; i < trans.orderNumList.length; i++) {
                            //     console.log("entx27 trans.orderNumList[i]:" + trans.orderNumList[i]);
                            //     this.markSingleOrderDelivered(trans.orderNumList[i]);
                            // }

                            this.setState({ loading: false, receipNumOk: true, itemCosts: response.data.itemCosts });
                            // console.log("fitc31 item costs is there:" + JSON.stringify(response.data.itemCosts))
                        }

                        /**
                         * CHECK FOR ITEM COSTS
                         */
                        // if (response.data.itemCosts) {
                        //     console.log("fitc31 item costs is there:" + JSON.stringify(response.data.itemCosts))
                        //     this.setState({ itemCosts: response.data.itemCosts });
                        // } else {
                        //     console.log("fitc32 no no item costs  there:")
                        // }

                    })
                    .catch((error) => {
                        console.log(error);
                        //this.setState({ loading: false })
                    });
            }


            // console.log("entx12 transobject:" + JSON.stringify(trans, null, 3));


        }
    }

    // ##########################::  GET DISCOUNT CODES :##########################:
    getDiscountCodes = () => {
        // console.log("dscx12 +++++ getDiscountCodes - ");

        //call server to check RecieptNum
        axios.post(pythonApiIp + 'getDiscountCodes', {
            apiKey: "axcvb&dfd$$"
        })
            .then((response) => {
                console.log(response.data);

                console.log("dscx13 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false, discountCodeChoices: getDiscountCodesDropdown(response.data.discountCodes) });

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
        // }

    }

    // ##########################::  SECOND :##########################:
    checkReceiptNum = () => {
        // console.log("entx2 +++++ checkReceiptNum - ");
        // console.log("entx21 reciept_num:" + this.state.reciept_num);

        //call server to check RecieptNum
        axios.post(serverIp + 'billing/checkRecieptNum', {
            reciept_num: this.state.reciept_num
        })
            .then((response) => {
                console.log(response.data);

                console.log("entx22 result:" + response.data.result);

                if (response.data.result) {

                    this.setState({ loading: false, receipNumOk: true });

                } else {

                    this.setState({ loading: false });

                    alert(response.data.message);

                }
                //this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                //this.setState({ loading: false })
            });
        // }

    }

    // ##########################::  THIRD :##########################:
    getOrderNumList = () => {
        console.log("entx7 ++++++++ getOrdeNumList +++++++");

        let tempOrderNumList = [];

        //CHECK IF COMMA EXISTS
        if (this.state.order_num.includes(",")) {
            console.log("entx71 order number includes comma");

            //GET ARRAY OF ORDER NUMBERS
            let tempList = this.state.order_num;
            tempOrderNumList = tempList.split(',');
            console.log("entx72  split on commas:" + tempOrderNumList.toString());

            //this.validateOrderNums(tempOrderNumList);

        } else {
            console.log("entx73 no comma in order num, just one order num");

            //GET SINGLE ORDER NUM
            //let tempOrderNumList = [];

            tempOrderNumList.push(this.state.order_num);
            console.log("entx74 added order num to tempOrderNumList:" + tempOrderNumList.toString())

            //VALIDATE ORDER NUM
            //this.validateOrderNums(tempOrderNumList);
        }

        for (var i = 0; i < tempOrderNumList.length; i++) {
            console.log("entx75 processing order num:" + tempOrderNumList[i]);

            //CHECK LENGTHS
            if (tempOrderNumList[i].length < 4) {
                alert("Order num " + tempOrderNumList[i] + " must be greater than chars");
                //this.setState({ loading: false })
                tempOrderNumList = false;
                break;

                //CHECK IF NUMBER
            } else if (isNaN(tempOrderNumList[i])) {
                alert("Order num " + tempOrderNumList[i] + " must be a number");
                //this.setState({ loading: false })
                tempOrderNumList = false;
                break;

            } else {
                console.log("enxt23 orderNum is ok:" + tempOrderNumList[i]);
                //this.markSingleOrderDelivered(tempOrderNumList[i]);
                // this.setState({ loading: false })
            }
        }

        console.log("entx76 tempOrderNumList:" + tempOrderNumList.toString());
        console.log("entx76 tempOrderNumList:" + tempOrderNumList);
        return tempOrderNumList;
    }

    processOrderNums = () => {
        console.log("entx1000 ++++++++ processOrderNums +++++++");

        //CHECK IF COMMA EXISTS
        if (this.state.order_num.includes(",")) {
            console.log("entx1 order number includes comma");

            //GET ARRAY OF ORDER NUMBERS
            let tempList = this.state.order_num;
            let tempOrderNumList = tempList.split(',');
            console.log("entx10  split on commas:" + tempOrderNumList.toString());

            this.validateOrderNums(tempOrderNumList);

        } else {
            console.log("entx12 no comma in order num, just one order num");

            //GET SINGLE ORDER NUM
            let tempOrderNumList = [];

            tempOrderNumList.push(this.state.order_num);
            console.log("entx13 added order num to tempOrderNumList:" + tempOrderNumList.toString())

            //VALIDATE ORDER NUM
            this.validateOrderNums(tempOrderNumList);
        }
    }

    sendOrderNumsAmountRecAmountDep = () => {
        console.log("entx5 ++++++++ sendOrderNumsAmountRecAmountDep +++++++");
        if (this.state.amountDep.length < 4) {
            alert("amountDep num must be 4 chars, enter 0000 if the amount is ZERO")
        } else if (this.state.amountRec.length < 4) {
            alert("amountRec num must be 4 chars, enter 0000 if the amount is ZERO")

        } else if (this.state.amountRec != this.state.amountRecConfirm) {
            alert("Amount Rec and Amount Rec confirm do not match pls double check and reenter")

        } else if (this.state.amountDep != this.state.amountDepConfirm) {
            alert("Amount Dep and Amount Dep confirm do not match pls double check and reenter")
        } else {

            this.setState({ loading: true })
            this.processOrderNums();
        }
    }

    validateOrderNums = (tempOrderNumList) => {
        console.log("entx2 ++++++++ validateOrderNums +++++++");

        for (var i = 0; i < tempOrderNumList.length; i++) {
            console.log("entx21 processing order num:" + tempOrderNumList[i]);

            //CHECK LENGTHS
            if (tempOrderNumList[i].length < 4) {
                alert("Order num " + tempOrderNumList[i] + " must be 4 chars");
                this.setState({ loading: false })
                break;

                //CHECK IF NUMBER
            } else if (isNaN(tempOrderNumList[i])) {
                alert("Order num " + tempOrderNumList[i] + " must be a number");
                this.setState({ loading: false })
                break;

            } else {
                console.log("enxt23 orderNum is ok:" + tempOrderNumList[i]);
                // this.markSingleOrderDelivered(tempOrderNumList[i]);
                this.setState({ loading: false })
            }
        }

        // tempOrderNumList.map((orderNum) => {
        //     console.log("entx21 processing order num:"+orderNum);

        //     if(orderNum.length != 4){
        //         alert("Order num "+orderNum+" must be 4 chars");
        //         break;
        //     }else{
        //         console.log("enxt23 orderNum is ok:"+orderNum);
        //     }
        // })
    }


    async markSingleOrderDelivered(orderNum) {
        console.log("entx3 ++++++++ markSingleOrderDelivered +++++++");
        console.log("entx31 orderNum:" + orderNum);

        base.fetch('orders', {
            context: this,
            asArray: true,
            queries: {
                orderByChild: 'order_num',
                equalTo: parseInt(orderNum)
            },
            then(data) {


                //if order order returned
                if (data[0]) {

                    console.log("entx32 data:" + JSON.stringify(data[0]));


                    if (data[0].key) {
                        console.log("entx34 send asyncall to mark delivery");
                        console.log("entx33 order key:" + data[0].key);
                        //mark delivered in firebase
                        // this.markAsDelivered(data[0].key);

                        //this.asyncCall(data[0].key)



                        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                        let orderUpdates = {
                            status: Status.delivered,
                            lastUpdated: now,
                            lastUpdatedBy: "ivanmworozi@gmail.com",
                        }

                        //UPDATE FIREBASE
                        FbUtils.updateOrder(data[0].key, orderUpdates);

                        //SEND TO API
                        this.sendDeliveryUpdateToApi(data[0].key);

                    } else {
                        console.error("no order KEY found!");
                        alert("order number " + orderNum + " not found");
                    }
                } else {
                    console.error("no order found!");
                    alert("order number " + orderNum + " not found");
                }

                // this.setState({
                //     allOrders:data
                // })
            }
        });
    }

    testPromise = () => {
        console.log("recx1 ++++++++ testPromise +++++++");

        this.markReceiptNumOnOrder(16703, 5738, "checkString");
        this.markReceiptNumOnOrder(16703, 5738, "checkString");
        this.markReceiptNumOnOrder(16703, 5738, "checkString");

        // const myPromise = new Promise((resolve, reject) => {
        //     console.log("recx12 inside promise");
        //     this.markReceiptNumOnOrder(16703, 5738, "checkString");
        // });

        // myPromise.then((resolvedValue) =>{
        //     console.log("recx121 resolvedValue... its done");
        // }, (error) => {
        //     console.log("recx122 IT FAILED... its done");
        // })
        console.log("recxFFFFFF - DONE...");
    }

    markReceiptNumOnOrder(orderNum, receiptNum, checkString, receipt) {
        console.log("recx13 ++++++++ markReceiptNumOnOrder +++++++");
        console.log("recx14 receiptNum:" + receiptNum);
        console.log("recx15 checkString:" + checkString);

        base.fetch('orders', {
            context: this,
            asArray: true,
            queries: {
                orderByChild: 'order_num',
                equalTo: parseInt(orderNum)
            },
            then(data) {
                console.log("recx16 inside then....check here..");
                //if order order returned
                if (data[0]) {

                    console.log("recx17 data:" + JSON.stringify(data[0], null, 3));

                    if (data[0].key) {
                        console.log("recx18 found order key going to add receipt number");
                        console.log("recx19 order key:" + data[0].key);

                        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
                        let orderUpdates = {
                            recieptNum: receiptNum,
                            receiptAmountRec: receipt.amountRec,
                            receiptAmountDep: receipt.amountDep,
                            recieptCheckString: checkString,
                            reciptNumUpdated: now,
                            receiptEnteredBy: this.state.user.email,
                            status: Status.delivered
                        }

                        //UPDATE FIREBASE
                        FbUtils.updateOrder(data[0].key, orderUpdates);
                        //SEND TO API
                        this.sendDeliveryUpdateToApi(data[0].key);


                    } else {
                        console.error("markReceiptNumOnOrder no order KEY found!");
                        alert("order number " + orderNum + " not found");
                    }
                } else {
                    console.error("markReceiptNumOnOrder no order found!");
                    alert("order number " + orderNum + " not found");
                }

                // this.setState({
                //     allOrders:data
                // })
            }
        });
    }

    // ##########################::  EIGHT :##########################:
    initOrderItemsArray = () => {
        console.log("entx7 ++++++++ initOrderItemsArray +++++++");

        this.addItemToOrderItemsArray();

    }

    addItemToOrderItemsArray = () => {
        console.log("entx7 ++++++++ initOrderItemsArray +++++++");


        let firstObject = {

            // items: 'nothing'
        }
        let tempArray = this.state.orderItemsArray;
        tempArray.push(firstObject);

        this.setState({ orderItemsArray: tempArray });

        console.log("entx71 firstObject added to tempArray:" + JSON.stringify(tempArray, null, 3));
    }

    calculateItemTotal = (orderArray) => {
        console.log("entx227 +++++++: calculateItemTotal");
        console.log("entx227: FULL ARRAY:" + JSON.stringify(orderArray, null, 3));

        let tempTotal = 0;

        orderArray.map((item) => {
            console.log("entx2271: inside array item:" + item.name);
            tempTotal += (item.quantity * item.rate);
            console.log("entx2271:tempTotal it now:" + tempTotal);
        })
        this.setState({ itemTotal: tempTotal })

        return tempTotal;
    }

    // ##########################::  NINE - updateOrderArray :##########################:
    updateOrderArray = (index, item, value) => {
        console.log("+++++++: updateOrderArray");
        console.log("entx22 cxx5: index:" + index);
        console.log("entx223:  item:" + item);
        console.log("entx224:  value:" + value);

        let orderArray = this.state.orderItemsArray;

        orderArray[index][item] = value;
        console.log("entx225: single value added:" + JSON.stringify(orderArray[index][item], null, 3));
        console.log("entx226: FULL ARRAY:" + JSON.stringify(orderArray, null, 3));

        this.setState({
            orderItemsArray: orderArray
        })

        this.calculateItemTotal(orderArray);

        //SEND ORDER ARRAY TO MAIN ORDER FORM
        //UPDATE ORDER ARRAY
        //this.props.updateSingleOrderArray(orderArray);

    }

    markDeliveries = (orders) => {
        console.log("++++++++ markDeliveries +++++++");

        orders.map((order) => {
            console.log("in loop orderNum:" + order);

            //SEND BILLING TO SERVER
            this.sendBilling(order.orderNum, order.amountDep, order.amountRec, order.items, order.reciept_num);

            base.fetch('orders', {
                context: this,
                asArray: true,
                queries: {
                    orderByChild: 'order_num',
                    equalTo: order.orderNum
                },
                then(data) {
                    console.log("data:" + JSON.stringify(data[0]));
                    console.log("orderNumb:" + data[0].key);

                    //if order order returned
                    if (data[0]) {

                        if (data[0].key) {
                            // this.markAsDelivered(data[0].key);

                            //  this.sendDeliveryGuy(data[0].key, order.del)

                            //send billing
                            // this.sendBilling(order.orderNum, order.amountDep, order.amountRec, order.items, order.reciept_num);

                            //mark delivered in firebase
                            // this.markAsDelivered(data[0].key);
                            // this.asyncCall(data[0].key)

                            // Promise.resolve()
                            //     .then(() => this.markAsDelivered(data[0].key))
                            //     .catch(e => this.handleCatch(1, e))
                            // console.log("px12 promoise ended");


                        } else {
                            console.error("no order KEY found!");
                        }
                    } else {
                        console.error("no order found!");
                    }

                    // this.setState({
                    //     allOrders:data
                    // })
                }
            });
        })
    }


    async asyncCall(key) { //eslint-disable-line 
        console.log('+++++ calling asyncCall');
        var result = await this.markAsDelivered(key);
        console.log(result);
        // expected output: 'resolved'
    }

    /**
 * SEND TO CONFIRM ORDER
 */
    markAsDelivered = (orderKey) => {
        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            status: Status.delivered,
            lastUpdated: now,
            lastUpdatedBy: "ivanmworozi@gmail.com",
        }

        //UPDATE FIREBASE
        FbUtils.updateOrder(orderKey, orderUpdates);

        //SEND TO API
        this.sendDeliveryUpdateToApi(orderKey);
    }

    //GET THE FIRST ORDER NUBMER FOR SEND BILLING FUNCTION
    getFirstOrderNumForBilling = () => {
        console.log("+++++ getFirstOrderNumForBilling entx - ");

        if (this.state.order_num.includes(",")) {
            console.log("entx1 order number includes comma");

            //GET ARRAY OF ORDER NUMBERS
            let tempList = this.state.order_num;
            let tempOrderNumList = tempList.split(',');

            return tempOrderNumList[0];

        } else {
            console.log("entx12 no comma in order num, just one order num");

            return this.state.order_num;
        }

    }

    sendBilling = () => {
        console.log("+++++ sendBilling entx - " + this.getFirstOrderNumForBilling() + " " + this.state.amountDep + " " + this.state.amountRec);
        console.log("entx667:" + JSON.stringify(this.state.orderItemsArray, null, 3));

        if (this.state.amountDep.length < 4) {
            alert("amountDep num must be 4 chars, enter 0000 if the amount is ZERO")
        } else if (this.state.amountRec.length < 4) {
            alert("amountRec num must be 4 chars, enter 0000 if the amount is ZERO")
        } else if (this.state.date === '') {
            alert("please select the date the orders was DELIVERED.. not the day you are entering the receipt")
        } else if (this.state.amountRec != this.state.amountRecConfirm) {
            alert("Amount Rec and Amount Rec confirm do not match pls double check and reenter")

        } else if (this.state.amountDep != this.state.amountDepConfirm) {
            alert("Amount Dep and Amount Deo confirm do not match pls double check and reenter")

        } else if ((parseInt(this.state.amountDep) + parseInt(this.state.amountRec)) !== parseInt(this.state.itemTotal)) {
            alert("Amount Dep + Amount Rec:" + (parseInt(this.state.amountDep) + parseInt(this.state.amountRec))
                + " does not equal the total amount of the items you entered" + parseInt(this.calculateItemTotal)
                + ", pls recheck")
        } else {

            this.setState({ loading: true });

            let orderNumList = this.getOrderNumList();
            let receiptNum = this.state.reciept_num;

            axios.post(serverIp + 'billing/loadReceipt', {
                order_num: this.getFirstOrderNumForBilling(),
                amountDep: this.state.amountDep,
                amountRec: this.state.amountRec,
                items: this.state.orderItemsArray,
                reciept_num: this.state.reciept_num,
                adminEmail: this.state.user.email,
                orderNumList: orderNumList,
                dateDelivered: this.state.date,
                discountCode: this.state.discountCode,
            })
                .then((response) => {
                    console.log(response.data);

                    if (response.data.result) {

                        let tempSentOrders = this.state.sentOrders;
                        tempSentOrders.push(this.state.order_num);

                        // saveRecItemList(response.data.reciept_num, this.state.orderItemsArray);

                        this.setState({ loading: false, sentOrders: tempSentOrders });
                        this.resetFields();

                        // MARK order with receipt num and checkString
                        for (var i = 0; i < orderNumList.length; i++) {
                            console.log("recx2 trans.orderNumList[i]:" + orderNumList[i]);
                            console.log("recx21 this.state.reciept_num:" + this.state.reciept_num);
                            console.log("recx21 receiptNum local:" + receiptNum);

                            //this.markSingleOrderDelivered(trans.orderNumList[i]);

                            this.markReceiptNumOnOrder(orderNumList[i], receiptNum, response.data.checkString, response.data.receipt);

                            // for (var i = 0; i < trans.orderNumList.length; i++) {
                            //     console.log("entx27 trans.orderNumList[i]:" + trans.orderNumList[i]);
                            //     this.markSingleOrderDelivered(trans.orderNumList[i]);
                            // }
                        }

                        alert("WRITE THIS NUMBER ON THE RECEIPT:" + response.data.checkString)

                    } else {
                        this.setState({ loading: false });
                        alert(response.data.message);

                    }

                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    /**
   * send bill receipts
   */
    sendBillingOLD = (order_num, amountDep, amountRec, items, reciept_num) => {
        console.log("+++++ sendBilling - " + order_num + " " + amountDep + " " + amountRec);

        axios.post(serverIp + 'billing/loadReceipt', {
            order_num: order_num,
            amountDep: amountDep,
            amountRec: amountRec,
            items: items,
            reciept_num: reciept_num
        })
            .then((response) => {
                console.log(response.data);

                if (response.data.result) {

                    let tempSentOrders = this.state.sentOrders;
                    tempSentOrders.push(order_num)

                    this.setState({ loading: false, sentOrders: tempSentOrders });

                } else {
                    this.setState({ loading: false });
                    alert(response.data.message);

                }
                this.resetFields();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });
    }

    sendDeliveryUpdateToApi = (orderKey) => {
        console.log("+++++ sendDeliveryUpdateToApi - " + orderKey);

        var d = new Date();
        var tt = d.getTime();
        var ts = d.toDateString();

    }

    resetFields = () => {
        console.log("+++ - reset Feilds");

        this.setState({
            reciept_num: '',
            order_num: '',
            amountDep: '',
            amountRec: '',
            amountDepConfirm: '',
            amountRecConfirm: '',
            selectedItem: '',
            qty1: '',
            price1: '',
            item1: '',
            samplePrice: '',
            quickSelect: '',
            orderItemsArray: [],
            receipNumOk: false
            //receipNumOk: true
        })


        this.addItemToOrderItemsArray();

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        this.setState({ date: date })
    }

    handleDropDownChanges = (value) => {
        console.log("handleDropDownChanges");
        console.log('cv32 You\'ve sss:', value);
        console.log('cv32 You\'ve selected:', value.value + " " + value.category);


        this.setState({
            discountCode: value.value
        });
    }

    render() {

        const sentOrders = this.state.sentOrders.map((orderNum) =>
            <h4 key={orderNum}>{orderNum + "|| "}</h4>
        )


        const orderItemArrayUi = this.state.orderItemsArray.map((orderItem, index) =>
            <RecItem
                key={index}
                arrayIndex={index}
                addItemToOrderItemsArray={this.addItemToOrderItemsArray}
                updateOrderArray={this.updateOrderArray} />
        )


        const orderNumAmountDepAmountRecUI =
            // <Form size='large' onSubmit={this.sendOrderNumsAmountRecAmountDep}>
            <Segment stacked>
                {itemCostsUI}

                <h5>DATE ORDER WAS DELIVERED</h5>
                <SingleDatePicker
                    date={this.state.date} // momentPropTypes.momentObj or null
                    //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                    onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                    focused={this.state.focused} // PropTypes.bool
                    isOutsideRange={() => false}
                    onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
                />

                <h2>TOTAL AMOUNT:{parseInt(this.state.amountDep) + parseInt(this.state.amountRec)}</h2>
                <h2>TOTAL ITEM AMOUNT:{this.state.itemTotal}</h2>


                {/* Amount Dep */}
                <Form.Field>
                    <label>Amount Deposited</label>
                    <label>{toCurrency(this.state.amountDep)}</label>
                    <Form.Input
                        fluid
                        name={'amountDep'}
                        value={this.state.amountDep}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Amount Dep'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='number'
                    //error={props.formErrorFieldArray['name']}
                    />
                </Form.Field>

                {/* Amount Rec */}
                <Form.Field>
                    <label>Amount Received</label>
                    <label>{toCurrency(this.state.amountRec)}</label>
                    <Form.Input
                        fluid
                        name={'amountRec'}
                        value={this.state.amountRec}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Amount Rec'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='number'
                    //error={props.formErrorFieldArray['name']}
                    />
                </Form.Field>
                {/* <Button color='blue' fluid size='large'>SEND ORDER NUM</Button> */}

                {/* Amount Dep CONFIRM */}
                <Form.Field>
                    <label>ENTER Amount Deposited AGAIN</label>
                    <label>{toCurrency(this.state.amountDepConfirm)}</label>
                    <Form.Input
                        fluid
                        name={'amountDepConfirm'}
                        value={this.state.amountDepConfirm}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Amount Dep Confirmation'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='number'
                    //error={props.formErrorFieldArray['name']}
                    />
                </Form.Field>

                {/* Amount Rec */}
                <Form.Field>
                    <label>ENTER Amount Received AGAIN</label>
                    <label>{toCurrency(this.state.amountRecConfirm)}</label>
                    <Form.Input
                        fluid
                        name={'amountRecConfirm'}
                        value={this.state.amountRecConfirm}
                        icon='add user'
                        iconPosition='left'
                        placeholder='Amount Rec Confirmation'
                        // onFocus={props.amp_logFieldClick}
                        onChange={this.handleTextInputChange}
                        type='number'
                    //error={props.formErrorFieldArray['name']}
                    />
                </Form.Field>

                {/* Discount Code */}
                <Form.Field>
                    <label>DISCOUNT CODE:{this.state.discountCode}</label>
                    <Select
                        name="form-field-name"
                        value={this.state.discountCode}
                        options={this.state.discountCodeChoices}
                        onChange={this.handleDropDownChanges}
                        searchable={false}
                        clearable={false}
                    />
                </Form.Field>


                <label> DOCUMENT TYPE </label>


                {orderItemArrayUi}
            </Segment>
        // </Form>


        const UiAfterReceiptOk = this.state.receipNumOk
            ? <Form size='large' onSubmit={this.sendBilling}>

                {orderNumAmountDepAmountRecUI}

                {/* {orderItemArrayUi} */}

                <br />
                <Button color='blue' fluid size='large'>Send</Button>

            </Form>
            : ''

        const userEmail = this.state.user && this.state.user.email
            ? <h3>{this.state.user.email}</h3>
            : 'no email'

        // const itemCostsUI = this.state.itemCosts.length > 0
        //     ? <h4>{this.state.itemCosts.length}</h4>
        //     : <h5>ITEM COSTS EMPTY</h5>

        const itemCostsUIHeader = this.state.itemCosts.length > 0
            ? <Divider horizontal>{'ITEM COSTS'}</Divider>
            : <h5>ITEM COSTS EMPTY</h5>

        // const itemCostsUI = this.state.itemCosts.length > 0
        //     ? this.state.itemCosts.map((item) =>
        //         <div> <ViewOrderLinkAlgolia order_num={item.order_num} /> -- {item.itemCost}</div>
        //     )
        //     : ''


        const itemCostsUI = this.state.itemCosts.length > 0
            ? <ItemCosts itemCosts = {this.state.itemCosts} />
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("enterReceipts")
            ? <div>

                {sentOrders}

                {/* fix this... */}
                <Form size='large' onSubmit={this.checkReceiptNumAndOrderNum}>
                    {/* <Form size='large' onSubmit={this.testPromise}> */}
                    <Segment stacked>

                        {/* order num */}
                        <Form.Field>
                            <label>Receipt Num</label>
                            <Form.Input
                                fluid
                                name={'reciept_num'}
                                value={this.state.reciept_num}
                                icon='add user'
                                iconPosition='left'
                                placeholder='reciept_num'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                                type='number'
                                maxLength='3'
                            //error={props.formErrorFieldArray['name']}
                            />
                        </Form.Field>

                        {/* order num */}
                        <Form.Field>
                            <label>Order Numbers (enter each one separated by comman)</label>
                            <Form.Input
                                fluid
                                name={'order_num'}
                                value={this.state.order_num}
                                icon='add user'
                                iconPosition='left'
                                placeholder='Order Num'
                                // onFocus={props.amp_logFieldClick}
                                onChange={this.handleTextInputChange}
                            //type='number'
                            //maxLength='4'
                            //error={props.formErrorFieldArray['name']}
                            />
                        </Form.Field>

                        <Button color='blue' fluid size='large'>CHECK RECEIPT NUM</Button>
                    </Segment>
                </Form>

                {/* FOR ENTERING ORDER NUM AND AMOUNT REC AMOUNT DEP */}
                {/* {orderNumAmountDepAmountRecUI} */}

                {itemCostsUIHeader}
                    {itemCostsUI}

                {/* SHOWS ARE THE RECEIPT SHOWS OK */}
                {UiAfterReceiptOk}


            </div>
            : <div><h2>YOU ARE NOT AN AUTHORIZED</h2>{userEmail}</div>

        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :

                <div>

                    {wholeUI}
                </div>
        );
    }
}

export default EnterReceiptsDynamic;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/EnterReceipts/EnterReceiptsDynamic.js